import React, { useEffect, useState } from "react";
import _ from "lodash";
import AutocompleteDropdown from "../../modules/ClinitianAvailabilityFilter/AutocompleteDropdown";
import "./TimePicker.scss";

type Props = {
    selectedDayOfWeek?: string[],
    selectedStartTime?: string,
    selectedEndTime?: string,
    handleAvailabilityFilter: Function,
};

type FilterSelectionOption = {
    label: string,
    unique_key: string,
    selected?: boolean,
};

export const DefaultAvailabilityFilter: AvailabilityFilter = {
    timeFrom: "",
    timeTo: "",
    weekDaysFilter: [],
};

const DaysOfWeekFilterData = {
    filter_selection_data: [
        { label: "Monday", unique_key: "MON", selected: false },
        { label: "Tuesday", unique_key: "TUE", selected: false },
        { label: "Wednesday", unique_key: "WED", selected: false },
        { label: "Thursday", unique_key: "THU", selected: false },
        { label: "Friday", unique_key: "FRI", selected: false },
        { label: "Saturday", unique_key: "SAT", selected: false },
        { label: "Sunday", unique_key: "SUN", selected: false },
    ],
    filter_label: "Day of week"
};

const TimeRanges = {
    filter_selection_data: [
        { label: "12:00 AM", unique_key: "12:00 AM" },
        { label: "12:30 AM", unique_key: "12:30 AM" },
        { label: "01:00 AM", unique_key: "01:00 AM" },
        { label: "01:30 AM", unique_key: "01:30 AM" },
        { label: "02:00 AM", unique_key: "02:00 AM" },
        { label: "02:30 AM", unique_key: "02:30 AM" },
        { label: "03:00 AM", unique_key: "03:00 AM" },
        { label: "03:30 AM", unique_key: "03:30 AM" },
        { label: "04:00 AM", unique_key: "04:00 AM" },
        { label: "04:30 AM", unique_key: "04:30 AM" },
        { label: "05:00 AM", unique_key: "05:00 AM" },
        { label: "05:30 AM", unique_key: "05:30 AM" },
        { label: "06:00 AM", unique_key: "06:00 AM" },
        { label: "06:30 AM", unique_key: "06:30 AM" },
        { label: "07:00 AM", unique_key: "07:00 AM" },
        { label: "07:30 AM", unique_key: "07:30 AM" },
        { label: "08:00 AM", unique_key: "08:00 AM" },
        { label: "08:30 AM", unique_key: "08:30 AM" },
        { label: "09:00 AM", unique_key: "09:00 AM" },
        { label: "09:30 AM", unique_key: "09:30 AM" },
        { label: "10:00 AM", unique_key: "10:00 AM" },
        { label: "10:30 AM", unique_key: "10:30 AM" },
        { label: "11:00 AM", unique_key: "11:00 AM" },
        { label: "11:30 AM", unique_key: "11:30 AM" },
        { label: "12:00 PM", unique_key: "12:00 PM" },
        { label: "12:30 PM", unique_key: "12:30 PM" },
        { label: "01:00 PM", unique_key: "01:00 PM" },
        { label: "01:30 PM", unique_key: "01:30 PM" },
        { label: "02:00 PM", unique_key: "02:00 PM" },
        { label: "02:30 PM", unique_key: "02:30 PM" },
        { label: "03:00 PM", unique_key: "03:00 PM" },
        { label: "03:30 PM", unique_key: "03:30 PM" },
        { label: "04:00 PM", unique_key: "04:00 PM" },
        { label: "04:30 PM", unique_key: "04:30 PM" },
        { label: "05:00 PM", unique_key: "05:00 PM" },
        { label: "05:30 PM", unique_key: "05:30 PM" },
        { label: "06:00 PM", unique_key: "06:00 PM" },
        { label: "06:30 PM", unique_key: "06:30 PM" },
        { label: "07:00 PM", unique_key: "07:00 PM" },
        { label: "07:30 PM", unique_key: "07:30 PM" },
        { label: "08:00 PM", unique_key: "08:00 PM" },
        { label: "08:30 PM", unique_key: "08:30 PM" },
        { label: "09:00 PM", unique_key: "09:00 PM" },
        { label: "09:30 PM", unique_key: "09:30 PM" },
        { label: "10:00 PM", unique_key: "10:00 PM" },
        { label: "10:30 PM", unique_key: "10:30 PM" },
        { label: "11:00 PM", unique_key: "11:00 PM" },
        { label: "11:30 PM", unique_key: "11:30 PM" },
    ],
};

const TimeImage = ({
    selectedDayOfWeek = [],
    selectedStartTime,
    selectedEndTime,
    handleAvailabilityFilter,
}: Props) => {
    const [filterObject, setFilterObject] = useState();
    const _daysOfWeekFilterData = _.cloneDeep(DaysOfWeekFilterData);

    if (selectedDayOfWeek?.length) {
        _daysOfWeekFilterData?.filter_selection_data.forEach((filterSelection: FilterSelectionOption) => {
            if (selectedDayOfWeek.includes(filterSelection.unique_key)){
                filterSelection.selected = true;
            }
        });
    }

    const [daysOfWeek, setDaysOfWeek] = useState(_daysOfWeekFilterData);

    const _startTimeData = _.cloneDeep(TimeRanges);

    if(selectedStartTime) {
        _startTimeData?.filter_selection_data.forEach((filterSelection: FilterSelectionOption) => {
            if (selectedStartTime === filterSelection.unique_key){
                filterSelection.selected = true;
            }
        });
    }

    const _endTimeData = _.cloneDeep(TimeRanges);

    if(selectedEndTime) {
        _endTimeData?.filter_selection_data.forEach((filterSelection: FilterSelectionOption) => {
            if (selectedEndTime === filterSelection.unique_key){
                filterSelection.selected = true;
            }
        });
    }

    const handleDayOfWeekChange = (value) => {
        const days = value.map((day) => day.unique_key);

        setDaysOfWeek(daysOfWeek);
        setFilterObject({ ...filterObject, weekDaysFilter: days });
    };

    useEffect(() => {
        const filterObj: AvailabilityFilter = {
            timeFrom: selectedStartTime || "",
            timeTo: selectedEndTime || "",
            weekDaysFilter: selectedDayOfWeek || [],
        };

        setFilterObject(filterObj);
    }, []);

    useEffect(() => {
        handleAvailabilityFilter(filterObject);
    }, [filterObject]);

    const styles = {
        timeContainer: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
            marginTop: "7px",
        },
    };

    const handleStartTimeChange = (value) => {
        setFilterObject({ ...filterObject, timeFrom: value?.label || "" });
    };

    const handleEndTimeChange = (value) => {
        setFilterObject({ ...filterObject, timeTo: value?.label || "" });
    };

    return (
        <div className="time-picker ca-filter">
            {daysOfWeek && (
                <AutocompleteDropdown
                    type={"multi-checkbox"}
                    filter={daysOfWeek}
                    onFilterValueUpdated={(filter, value) => {
                        handleDayOfWeekChange(value);
                    }}
                    sx={{ width: "100%", m: 1 }}
                />
            )}
            <div
                style={styles.timeContainer}
                className="ca-filter time-container"
            >
                <AutocompleteDropdown
                    type={"single-checkbox"}
                    filter={{ ..._startTimeData, filter_label: "Start Time" }}
                    onFilterValueUpdated={(filter, value) => {
                        handleStartTimeChange(value);
                    }}
                    className={"start-time"}
                    checkbox={false}
                    sx={{ width: "49%", m: 1 }}
                />
                <AutocompleteDropdown
                    type={"single-checkbox"}
                    filter={{ ..._endTimeData, filter_label: "End Time" }}
                    onFilterValueUpdated={(filter, value) => {
                        handleEndTimeChange(value);
                    }}
                    className={"end-time"}
                    checkbox={false}
                    sx={{ width: "49%", m: 1 }}
                />
            </div>
        </div>
    );
};

export default TimeImage;